import WildAppResource from "./WildAppResource";
import ThirdPartyIntegrationsAppResource from './ThirdPartyIntegrationsAppResource';

class ThirdPartyIntegrationsPivotAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'third-party-integration-pivot';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'thirds/parties/integrations-pivots';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'createdAt',
            'updatedAt',
            'thirdPartyUuid',
            'modelUuid',
            'modelType',
            'integrations',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            integrations: ThirdPartyIntegrationsAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            integrations: 'third_party_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {

        };
    }

}

export default ThirdPartyIntegrationsPivotAppResource;
